import {useAuth} from '../../Maindashboard/Context/AuthContext';
export function canExportReport(auth,view){
 const key=view.endsWith('.view')?view.slice(0,-5)+'.export':view+'.export';
 return auth?.user?.role==='super_admin'||Boolean(auth?.user&&(auth.permissions||[]).includes(view)&&(auth.permissions||[]).includes(key));
}
export default function ReportExportButton({viewPermission,children,...props}){
 const auth=useAuth();
 return canExportReport(auth,viewPermission)?<button {...props}>{children}</button>:null;
}
